// Kept out of progress.ts so the fake can import it without loading the real client.
export type ProgressErrorDetail = {
  field: string;
  message: string;
  type: string;
};

export type ProgressErrorBody = {
  details: ProgressErrorDetail[] | null;
  error: string;
  message: string;
};

export class ProgressRequestError extends Error {
  details: ProgressErrorDetail[];

  error: string;

  status: number;

  constructor(status: number, body: ProgressErrorBody) {
    super(body.message);
    this.name = 'ProgressRequestError';
    this.details = body.details ?? [];
    this.error = body.error;
    this.status = status;
  }
}

export function isProgressUnauthorized(error: unknown) {
  return error instanceof ProgressRequestError && error.status === 401;
}
